"use client";

import { Card, LiquidPill } from "components/ui/v2";
import useTranslation from "next-translate/useTranslation";
import Image from "next/legacy/image";

export function PublicProfileMarketingCtaV2() {
  const { t } = useTranslation("common");

  return (
    <Card size="full" padding="comfortable" shadow="subtle">
      <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
        <Image
          src="/svg/logo/isotipoBrandV2.svg"
          alt="isotipo"
          width={70}
          height={70}
          unoptimized
        />
        <div className="flex flex-col justify-center text-center md:text-left">
          <h3 className="mb-2 text-xl font-bold text-slate-900 dark:text-white">
            {t("¿Quieres optimizar tu organización?")}
          </h3>
          <p className="text-sm text-slate-600 dark:text-zinc-400">
            {t(
              "Necesitas hacer crecer tu organización, obtener métricas y hacer seguimiento de los colaboradores y sus proyectos ¡Prueba Groowcity totalmente gratis!"
            )}
          </p>
        </div>
        <LiquidPill
          as="button"
          type="button"
          variant="indigo"
          appearance="tinted"
          shadow="neutral"
          size="md"
          text={t("Recomendar")}
          onClick={() => window.open("https://www.groowcity.com/", "_blank", "noopener,noreferrer")}
        />
      </div>
    </Card>
  );
}
